<template>
    <div class="container">
        <span>店内订单明细</span>
        <div class="search-box">
            <el-form label-position="left" label-width="100px">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="结账时间" prop="checkOutTime">
                            <el-date-picker style="width: 100%;" v-model="queryInfo.condition.checkOutTime"
                                type="datetime" placeholder="选择结账时间"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="订单来源" prop="sourceCode">
                            <el-select v-model="queryInfo.condition.sourceCode" placeholder="请选择订单来源">
                                <el-option label="收银" value="cashier"></el-option>
                                <el-option label="网页" value="wap"></el-option>
                                <el-option label="微信小程序" value="mini"></el-option>
                                <el-option label="饿了么" value="ele"></el-option>
                                <el-option label="美团" value="meituan"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="订单号" prop="tableName">
                            <el-input v-model="queryInfo.condition.orderNumber" placeholder="请输入订单号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="支付类型" prop="payType">
                            <el-input v-model="queryInfo.condition.payType" placeholder="请输入支付类型"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">

                    <el-col :span="6">
                        <el-form-item label="已支付金额" prop="sumPaid">
                            <el-input type="number" v-model="queryInfo.condition.sumPaid" label="已支付金额"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="桌台区域名称" prop="tableAreaName">
                            <el-input v-model="queryInfo.condition.tableAreaName" placeholder="请输入桌台区域名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="服务员名称" prop="waiterName">
                            <el-input v-model="queryInfo.condition.waiterName" placeholder="请输入服务员名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="需要支付金额" prop="sumToPay">
                            <el-input type="number" v-model="queryInfo.condition.sumToPay" :min="0"
                                label="需要支付金额"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="桌台名称" prop="tableName">
                            <el-input v-model="queryInfo.condition.tableName" placeholder="请输入桌台名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="订单来源名称" prop="sourceName">
                            <el-input v-model="queryInfo.condition.sourceName" placeholder="请输入订单来源名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="text-align: right;">
                        <el-button type="primary" icon="el-icon-search"
                            style="margin-left: 20px;background-color: #f59a23;border: none;"
                            @click="search">查询</el-button>
                        <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>

        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.label" :name="item.name">

            </el-tab-pane>

        </el-tabs>
        <el-table :data="tableData" style="width: 98%" border v-loading="loading">
            <el-table-column prop="orderNumber" label="订单号" align="center" width="200"></el-table-column>
            <el-table-column prop="sourceName" label="订单来源" align="center">
                <!--  <template slot-scope="scope">
                    {{ scope.row.sourceCode === 'cashier' ? '收银' : scope.row.sourceCode === 'wap' ? '网页' :
                        scope.row.sourceCode === 'mini' ? '微信小程序' : scope.row.sourceCode === 'ele' ? '饿了么' :
                            scope.row.sourceCode === 'meituan' ? '美团' : '未知' }}
                </template> -->
            </el-table-column>
            <el-table-column prop="checkOutTime" label="结账时间" align="center" width="200"></el-table-column>
            <el-table-column prop="refundTime" label="退款时间" align="center" width="200"></el-table-column>
            <el-table-column prop="peopleCount" label="用餐人数" align="center" width="150"></el-table-column>
            <el-table-column prop="sumConsume" label="订单原始金额" align="center" width="200"></el-table-column>
            <el-table-column prop="sumToPay" label="需要支付金额" align="center" width="150"></el-table-column>
            <el-table-column prop="sumPaid" label="已支付金额" align="center" width="200"></el-table-column>
            <el-table-column prop="payTypeName" label="支付类型编码" align="center" width="200"></el-table-column>
            <el-table-column prop="isCheckOut" label="是否结账" align="center" width="150">
                <template slot-scope="scope">
                    {{ scope.row.isCheckOut === 0 ? '未结账' : '已结账' }}
                </template>
            </el-table-column>
            <el-table-column prop="waiterName" label="服务员名称" align="center" width="200"></el-table-column>
            <el-table-column prop="tableName" label="桌台名称" align="center" width="200"></el-table-column>
            <el-table-column prop="tableAreaName" label="桌台区域名称" align="center" width="200"></el-table-column>
            <!-- 订单详情按钮 -->
            <el-table-column label="操作" align="center" width="200" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="orderDetail(scope.row)">订单详情</el-button>
                </template>
            </el-table-column>

        </el-table>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.currPage" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            queryInfo: {
                condition: {},
                currPage: 1,
                pageCount: 1,
                pageSize: 10,
            },
            activeName: '1',
            tabs: [{
                label: '全部订单',
                name: '1'
            }, {
                label: '待接单',
                name: '2'
            }, {
                label: '待制作',
                name: '3'
            }, {
                label: '未结账',
                name: '4'
            }, {
                label: '已结账',
                name: '5'
            }, {
                label: '已撤单',
                name: '6'
            }, {
                label: '已退单',
                name: '7'
            }
            ],
            total: 0,
            tableData: [],
            loading: true
        };
    },
    mounted() {
        this.getData()
    },
    methods: {
        // 获取当前页面
        handleCurrentChange(val) {
            this.queryInfo.currPage = val;
            this.getData();
        },
        // 修改页数大小
        handleSizeChange(val) {
            this.queryInfo.pageSize = val;
            this.getData();
        },
        handleClick(tab, event) {
            this.queryInfo.condition.status = this.activeName
            this.search()
        },
        search() {
            this.getData()
        },
        reset() {
            this.queryInfo = {};
            this.getData()
        },
        async getData() {


            this.loading = true
            let res = await this.$http.post('/merchantOrderHistory/list', this.queryInfo)
            if (res.data.code == 200) {
                this.total = res.data.data.count;
                this.queryInfo.currPage = res.data.data.currPage;
                this.tableData = res.data.data.data;
                this.loading = false
            } else {
                this.loading = false
            }

        },
        orderDetail(row) {

            /* this.$router.push({
                path: '/orderDetail',
                query: {
                    id: row.id
                }
            }) */

        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 20px;
}

.search-box {
    width: 96%;
    margin: 20px auto;
}

/deep/ .el-tabs__active-bar {
    background-color: #f59a23;
    font-size: 16px !important;
}

/deep/ .el-tabs__item:hover {
    color: #f59a23;
    cursor: pointer;
}

/deep/ .el-tabs__item {
    color: #000;
    cursor: pointer;
}
</style>